// @flow
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import Lightbox from 'react-image-lightbox';
import { connect } from 'react-redux';

import {
  closeLightbox,
  changeLightboxIndex,
} from './../../redux/actions/lightboxStateActions';

import './lightbox.css';

type Props = {
  isOpen: boolean,
  imgIndex: number,
  images: Array<string>,
  closeLightbox: () => void,
  changeLightboxIndex: (index: number) => void,
};

const mapStateToProps = ({ lightboxState: { isOpen, images, imgIndex } }) => ({
  isOpen,
  images,
  imgIndex,
});

const mapDispatchToProps = dispatch => ({
  closeLightbox: () => dispatch(closeLightbox()),
  changeLightboxIndex: index => dispatch(changeLightboxIndex(index)),
});

const LightboxContainer = ({
  imgIndex = 0,
  isOpen,
  images = [],
  closeLightbox,
  changeLightboxIndex,
}: Props) => {
  const imagesLength = images.length;
  const nextSrcIndex = (imgIndex + 1) % imagesLength;
  const prevSrcIndex = (imgIndex + imagesLength - 1) % imagesLength;

  return (
    <div>
      {isOpen && (
        <Lightbox
          mainSrc={images[imgIndex]}
          nextSrc={images[nextSrcIndex]}
          prevSrc={images[prevSrcIndex]}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() => {
            if (!isEmpty(images)) changeLightboxIndex(nextSrcIndex);
          }}
          onMoveNextRequest={() => {
            if (!isEmpty(images)) changeLightboxIndex(prevSrcIndex);
          }}
        />
      )}
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LightboxContainer);



// WEBPACK FOOTER //
// ./src/components/Lightbox/LightboxContainer.jsx